const lanaData = {
  name: 'Lana Diaspora.',
  name2: 'THIAM Bamba.',
  name3: 'THIAM Bamba',
  role: "Association centrée sur l'humain & la planète,",
  ptext:
    "Association centrée sur l'humain & la planète à travers des accompagnements sur mesure ainsi que des projets de developpement communautaires et environnementaux au Sénégal,",
  socialLinks: [
    {
      name: 'Facebook',
      url: 'http://www.linkedin.com/',
      className: 'social_facebook',
    },
    {
      name: 'twitter',
      url: 'http://www.twitter.com/',
      className: 'social_twitter',
    },
    {
      name: 'googleplus',
      url: 'http://www.googleplus.com',
      className: 'social_googleplus',
    },
    {
      name: 'pinterest',
      url: 'http://www.pinterest.com',
      className: 'social_pinterest',
    },
  ],
  aboutme: 'Qui sommes-nous',
  aboutdetails:
    "Nous sommes une association déclarée, immatriculée sous le SIREN 831740709 basée en France. Elle est en activité depuis 2017 et est constituée essentiellement de ressortissant sénégalais de la diaspora. Elle est spécialisée dans le secteur d'activité des autres organisations fonctionnant par adhésion volontaire (association). Ses activités sont centrées sur l'humain et la planète à travers des accompagnements sur mesure ainsi que des projets de developpement communautaires et environnementaux au Sénégal.",
  service: [
    {
      id: 1,
      iconName: 'icon-pencil',
      serviceTitle: 'Etudes de projets',
      sDetails:
        "Nous intervenons sur des études de projets à fort impact social et communautaire dans le but d'aider les populatons locales à trouver des financements.",
    },
    {
      id: 2,
      iconName: 'icon-gears',
      serviceTitle: 'Intégration primo-arrivants',
      sDetails:
        "Nous accompagnons les primo-arrivants, venant du Sénégal dans leurs parcours d'intégration en France.",
    },
    {
      id: 3,
      iconName: 'icon-linegraph',
      serviceTitle: 'Stratégie',
      sDetails:
        'There are many variations of pssages of Lorm available, bu in some form, Lorem Ipsum is simply dummy text.',
    },
    {
      id: 4,
      iconName: 'icon-presentation',
      serviceTitle: 'Vente',
      sDetails:
        'Lorm available, bu in some form, of Lorm available, bu in some form, Lorem Ipsum is simply dummy text.',
    },
    {
      id: 5,
      iconName: 'icon-desktop',
      serviceTitle: 'Support-Conseil',
      sDetails:
        'TLorm available, bu in some form, of Lorm available, bu in some form, Lorem Ipsum is simply dummy text.',
    },
    {
      id: 6,
      iconName: 'icon-tools',
      serviceTitle: 'Expertise',
      sDetails:
        'There are many variations of pssages of Lorm available, bu in some form, Lorem Ipsum is simply dummy text.',
    },
  ],
  contact: [
    {
      id: '1',
      title: 'Contact Info',
      menuItems: [
        {
          id: 1,
          icon: 'icon_pin_alt',
          text: 'Address: 14, rue DE LA POTERIE 91100',
        },
        {
          id: 2,
          icon: 'icon_phone',
          text: 'Phone: +33 06 05 57 40 02',
        },
        {
          id: 3,
          icon: 'icon_mail',
          text: 'Email: lanadiaspora@gmail.com',
        },
        {
          id: 4,
          icon: 'icon_globe',
          text: 'Website: http://lanadiaspora.com',
        },
      ],
    },
  ],
  devloperBanner: [
    {
      id: 1,
      subtile: 'Front-End Developer',
      title: 'Talk is cheap. \n Show me the code',
      discription:
        'I design and code beautifully simple things,\n and I love what I do.',
    },
  ],
  devAbout: [
    {
      id: 1,
      smalltitle: 'Introduce',
      aHead: 'Passion \n Heart & Soul',
      aHeadTwo: 'Every great design begin with an even better story',
      adiscription:
        "Since beginning my journey as a freelancer designer nearly 4 years ago, I've done remote work for agencies, consulted for startups, and collaborated with talented people to create digital products for both business and consumer use, I am quietly confident, naturally curious.",
    },
  ],
  aboutSkill: [
    {
      id: 1,
      workName: 'Design',
      text: 'Create digital products with unique idea',
      complateProject: '20 Projects',
      icon: 'icon-tools',
    },
    {
      id: 2,
      workName: 'front-End',
      text: 'My coding structure is clean and smooth',
      complateProject: '165 Projects',
      icon: 'icon-genius',
    },
    {
      id: 3,
      workName: 'SEO',
      text: 'Boost your business with SEO optimize.',
      complateProject: '5 Projects',
      icon: 'icon-linegraph',
    },
  ],
  awards: [
    {
      id: 1,
      // image: 'logo1.png',
      image: 'logo1.png',
      ctile: 'Site of the year 2020',
      date: 'April 2020',
      description: 'For most favorited design voted by NY City Style customers',
      url: 'http://www.pinterest.com',
      linktext: 'view More',
    },
    {
      id: 2,
      image: 'logo1.png',
      image: 'Logo_lana/logo_lana.png',
      ctile: 'Theme of the day 2021',
      date: 'March 2021',
      description: 'For most favorited design voted by NY City Style customers',
      url: 'http://www.pinterest.com',
      linktext: 'view More',
    },
    {
      id: 3,
      // image: 'logo2.png',
      image: 'logo2.png',
      ctile: 'Best design awwards',
      date: 'March 2021',
      description: 'For most favorited design voted by NY City Style customers',
      url: 'http://www.pinterest.com',
      linktext: 'view More',
    },
  ],
  contacttitle: 'Contact Form',
}

export default lanaData
